import { defineAsyncComponent, markRaw } from 'vue'
export const tabs = [
  {
    label: '工单详情',
    key: 1,
    ref: 'workorderDetails',
    component: markRaw(defineAsyncComponent(() => import('@/views/Todo/workorderDetails.vue')))
  },
  {
    label: '会话记录',
    key: 2,
    ref: 'chat',
    component: markRaw(
      defineAsyncComponent(() => import('@/views/WorkPlace/Container/chat/history.vue'))
    )
  },
  {
    label: '健康信息',
    key: 3,
    ref: 'healthInfo',
    component: markRaw(defineAsyncComponent(() => import('@/views/HealthRecord/HealthInfo')))
  },
  {
    label: '问诊',
    key: 4,
    ref: 'Consult',
    component: markRaw(
      defineAsyncComponent(() => import('@/views/WorkPlace/Container/Consult/index.vue'))
    )
  },
  {
    label: '病历',
    key: 5,
    ref: 'MedicalRecord',
    component: markRaw(
      defineAsyncComponent(() => import('@/views/WorkPlace/Container/MedicalRecord/index.vue'))
    )
  },
  {
    label: '处方',
    key: 6,
    ref: 'Prescription',
    component: markRaw(
      defineAsyncComponent(() => import('@/views/WorkPlace/Container/Prescription/index.vue'))
    )
  },
  {
    label: '量表',
    key: 7,
    ref: 'Gauge',
    component: markRaw(
      defineAsyncComponent(() => import('@/views/WorkPlace/Container/Gauge/index.vue'))
    )
  },
  {
    label: '随访',
    key: 8,
    ref: 'Visits',
    component: markRaw(
      defineAsyncComponent(() => import('@/views/WorkPlace/Container/Visits/index.vue'))
    )
  },
  {
    label: '预约',
    key: 9,
    ref: 'Appoint',
    component: markRaw(
      defineAsyncComponent(() => import('@/views/WorkPlace/Container/Appoint/index.vue'))
    )
  },
  {
    label: '小结',
    key: 10,
    ref: 'Summary',
    component: markRaw(
      defineAsyncComponent(() => import('@/views/WorkPlace/Container/Summary/index.vue'))
    )
  },
  {
    label: '通话记录',
    key: 11,
    ref: 'CallLog',
    component: markRaw(
      defineAsyncComponent(() => import('@/views/WorkPlace/Container/CallLog/index.vue'))
    )
  },
  {
    label: '绑定医生',
    key: 12,
    ref: 'bindDocList',
    component: markRaw(
      defineAsyncComponent(() =>
        import('@/components/PatientInfoDetails/components/bindDocList.vue')
      )
    )
  }
]
